import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const CompanySettingsContext = createContext(null);
const API_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULTS = {
  company_name: 'MANHA DIGITAL',
  subtitle: 'Your Dreams, Our Deals',
  logo_url: '',
  login_bg_url: 'https://images.pexels.com/photos/10410074/pexels-photo-10410074.jpeg',
  address: '',
  phone: '',
  email: '',
  ntn: '',
};

export const useCompanySettings = () => useContext(CompanySettingsContext) || { settings: DEFAULTS, refresh: () => {} };

export const CompanySettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/settings/company`);
      setSettings({ ...DEFAULTS, ...data, login_bg_url: data.login_bg_url || DEFAULTS.login_bg_url });
    } catch (error) {
      // Keep defaults on failure
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <CompanySettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </CompanySettingsContext.Provider>
  );
};
